import React, { useEffect, useState } from "react";

const LightFooterSection = ({ footerHtml, formThemeData = {} }) => {
  const [contactInfo, setContactInfo] = useState({
    email: "support@info.com",
    phone: "**********",
  });
  const [cssType, setcssType] = useState({
    custom: false,
    dark: false,
    light: false,
  });
  const [customThemeFooter, setcustomThemeFooter] = useState("");

  const getFullYear = new Date().getFullYear()

  useEffect(() => {
    if (formThemeData?.contactInfo) {
      setContactInfo(formThemeData?.contactInfo);
    }

    if (formThemeData?.cssType && formThemeData?.cssType) {
      setcssType(formThemeData?.cssType);
    }

    if (
      formThemeData?.customThemeFooter &&
      Object.values(formThemeData?.customThemeFooter).length > 0
    ) {
      setcustomThemeFooter(formThemeData?.customThemeFooter);
    }
  }, [formThemeData]);

  return (
    <div className="pb-2">
      <footer aria-labelledby="footer-heading" className="relative z-10">
        <div className="container mx-auto">
          {(contactInfo?.phone || contactInfo?.email) && (
            <div className="bg-primary pt-[68px] pb-[72px] mb-[50px] overflow-hidden rounded-[8px] px-[13px] text-center">
              <div className="flex items-center justify-center gap-x-[16px] mb-[20px]">
                <div className="text-primarytext">
                  <svg
                    width="46"
                    height="31"
                    viewBox="0 0 46 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.59998 30.45C2.73998 30.45 2.02 30.1601 1.44 29.5701C0.860002 28.9901 0.559998 28.2599 0.559998 27.3999V3.48999C0.559998 2.62999 0.850002 1.91007 1.44 1.32007C2.02 0.740068 2.74998 0.439941 3.59998 0.439941H42.35C43.21 0.439941 43.93 0.730068 44.51 1.32007C45.09 1.90007 45.39 2.62999 45.39 3.48999V27.3999C45.39 28.2599 45.1 28.9801 44.51 29.5701C43.93 30.1501 43.2 30.45 42.35 30.45H3.59998ZM27.91 29.1001H42.34C42.76 29.1001 43.15 28.9201 43.51 28.5701C43.87 28.2201 44.04 27.8299 44.04 27.3999V3.5C44.04 3.08 43.86 2.69008 43.51 2.33008C43.16 1.98008 42.77 1.80005 42.34 1.80005H3.60999C3.18999 1.80005 2.8 1.98008 2.44 2.33008C2.09 2.68008 1.90997 3.07 1.90997 3.5V27.3999C1.90997 27.8199 2.09 28.2101 2.44 28.5701C2.79 28.9301 3.17999 29.1001 3.60999 29.1001H5.22998C6.69998 27.4601 8.40002 26.1201 10.33 25.0901C12.26 24.0601 14.34 23.55 16.57 23.55C18.8 23.55 20.86 24.0601 22.78 25.0801C24.71 26.1001 26.42 27.4401 27.91 29.0901V29.1001ZM16.55 20.4199C17.91 20.4199 19.07 19.94 20.03 18.99C20.99 18.04 21.47 16.88 21.47 15.53C21.47 14.18 20.99 13.0201 20.03 12.0701C19.07 11.1201 17.91 10.6399 16.56 10.6399C15.21 10.6399 14.05 11.1201 13.1 12.0701C12.15 13.0201 11.68 14.17 11.68 15.52C11.68 16.87 12.15 18.03 13.1 18.99C14.05 19.95 15.2 20.4299 16.56 20.4299L16.55 20.4199ZM35.74 26.4399L38.86 23.3401L36.45 20.1101H32.77C32.49 19.2501 32.29 18.47 32.18 17.75C32.07 17.03 32.02 16.27 32.02 15.45C32.02 14.63 32.07 13.89 32.18 13.21C32.29 12.53 32.48 11.7401 32.76 10.8101H36.45L38.86 7.57007L35.74 4.46997C34.11 5.82997 32.85 7.46011 31.97 9.36011C31.09 11.2601 30.64 13.29 30.64 15.45C30.64 17.61 31.08 19.64 31.97 21.54C32.85 23.44 34.11 25.0699 35.74 26.4299V26.4399ZM7.19 29.1001H25.92C24.71 27.7701 23.29 26.74 21.68 26.01C20.07 25.28 18.36 24.9099 16.56 24.9099C14.76 24.9099 13.05 25.28 11.44 26.01C9.83 26.74 8.42 27.7701 7.19 29.1001ZM16.56 19.0701C15.58 19.0701 14.75 18.72 14.06 18.02C13.37 17.32 13.03 16.49 13.03 15.53C13.03 14.57 13.37 13.73 14.06 13.03C14.75 12.33 15.58 11.98 16.55 11.98C17.52 11.98 18.36 12.33 19.06 13.02C19.76 13.71 20.11 14.54 20.11 15.5C20.11 16.46 19.76 17.3 19.06 18.01C18.36 18.72 17.53 19.0601 16.56 19.0601V19.0701Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
                <div className="text-primarytext">
                  <svg
                    width="40"
                    height="31"
                    viewBox="0 0 40 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.65002 30.45C2.73002 30.45 1.96002 30.14 1.33002 29.51C0.700017 28.88 0.390015 28.1099 0.390015 27.1899V3.70996C0.390015 2.78996 0.700017 2.01989 1.33002 1.38989C1.96002 0.759893 2.73002 0.449951 3.65002 0.449951H36.18C37.1 0.449951 37.87 0.759893 38.5 1.38989C39.13 2.01989 39.44 2.78996 39.44 3.70996V27.1899C39.44 28.1099 39.13 28.88 38.5 29.51C37.87 30.14 37.1 30.45 36.18 30.45H3.65002ZM19.91 14.98L1.84003 3.01001V27.1799C1.84003 27.7099 2.00998 28.15 2.34998 28.49C2.68998 28.83 3.12997 29 3.65997 29H36.16C36.69 29 37.13 28.83 37.47 28.49C37.81 28.15 37.98 27.7099 37.98 27.1799V3.01001L19.91 14.98ZM19.91 13.2L37.04 1.8999H2.77002L19.9 13.2H19.91ZM1.84003 3.01001V1.8999V27.1799C1.84003 27.7099 2.00998 28.15 2.34998 28.49C2.68998 28.83 3.12997 29 3.65997 29H1.84003V3.01001Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="mb-[20px] text-[24px] font-bold">
                <span className="text-primarytext">CUSTOMER SUPPORT</span>
              </div>
              <div className="mb-[20px] font-bold">
                <a
                  href={`tel:${contactInfo?.phone}`}
                  className="text-primarytext text-[16px] font-bold"
                >
                  {contactInfo?.phone}
                </a>
              </div>
              <div className="font-bold">
                <a
                  href={`mailto:${contactInfo?.email}`}
                  className="text-primarytext text-[16px] font-bold break-words"
                >
                  {contactInfo?.email}
                </a>
              </div>
            </div>
          )}

          <div className="bg-primary py-[40px] mb-[40px] overflow-hidden rounded-[8px]">
            <div className="lg:flex lg:flex-wrap lg:items-center lg:justify-between text-center lg:px-[65px]">
              <div className="px-[13px] lg:w-4/12 mb-[40px] lg:mb-0">
                <p className="lg:block inline-block">
                  <img
                    src={`${
                      cssType?.dark || customThemeFooter === "DarkThemeFooter"
                        ? "https://ystore.us/HTML/RedefineCommerce/store-builder/dark/images/product/one-per-for-plant-dark.svg"
                        : "https://ystore.us/HTML/RedefineCommerce/store-builder/light/images/product/one-per-for-plant-light.svg"
                    }`}
                    alt=""
                  />
                </p>
              </div>
              <div className="px-[13px] lg:w-4/12 text-center text-[14px] font-bold mb-[40px] lg:mb-0">
                <span className="text-primarytext">
                  {`© ${getFullYear} ParsonsKellogg All Rights Reserved`}
                  
                </span>
              </div>
              <div className="px-[13px] lg:w-4/12">
                {/* <div className="lg:flex lg:justify-end lg:items-center lg:flex-wrap text-center gap-x-[22px] hidden">
                  <div className="text-[14px] font-bold mb-[15px] lg:mb-0">
                    <span className="text-primarytext">WEACCEPT</span>
                  </div>
                  <div className="inline-block">
                    <img
                      src={`${
                        cssType?.dark || customThemeFooter === "DarkThemeFooter"
                          ? "" //https://ystore.us/HTML/RedefineCommerce/store-builder/dark/images/product/card-dark.svg
                          : "" //https://ystore.us/HTML/RedefineCommerce/store-builder/light/images/product/card-light.svg
                      }`}
                      alt=""
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div dangerouslySetInnerHTML={{ __html: footerHtml }} />
    </div>
  );
};

export default LightFooterSection;
